<template>
  <div class="Wdgt-Signal-Content">
    <template v-if="get_isLockPaidContent && !get_isUserLoading">
      <div class="Wdgt-Signal-Content__no-paid-box">
        <CapitalInfo />
      </div>
    </template>

    <template v-else>
      <div class="Wdgt-Signal-Content__box" v-if="get_signal">
        <header class="Wdgt-Signal-Content__hdr">
          <div class="Wdgt-Signal-Content__hdr-side">
            <BlockAuthorTimeCommentFire
              class="Wdgt-Signal-Content__stats"
              :date="get_time"
              :author="get_signal.author"
              :link="get_signal.link"
              :commentsCount="get_signal.comments_count"
              :initCommentsCount="get_signal.init_comments_count"
              @callComments="toCallComments"
            />
          </div>
          <div class="Wdgt-Signal-Content__hdr-side Wdgt-Signal-Content__hdr-side--end">
            <div class="Wdgt-Signal-Content__menu" ref="menuRef" v-if="get_isModerator">
              <PointsIcon class="Wdgt-Signal-Content__points-btn" @click="toToggleMenu" />
              <transition name="Anim__fadeUp">
                <DropMenuSignal class="Wdgt-Signal-Content__menu-box" :signalId="ID" v-if="isOpen" />
              </transition>
            </div>
          </div>
        </header>

        <div class="Wdgt-Signal-Content__wrapper">
          <div class="Wdgt-Signal-Content__content-hdr">
            <div class="Wdgt-Signal-Content__content-hdr-ttl-box">
              <component
                :is="get_signal.author?.profile_url ? 'a' : 'p'"
                class="Wdgt-Signal-Content__content-hdr-avt-user"
                ref="authorRef"
                :href="get_signal.author?.profile_url || null"
                target="_blank"
              >
                <AvatarImage :src="userAvatar" :size="20" v-if="userAvatar"/>
                {{ computedName }}
              </component>
              <h2 class="Wdgt-Signal-Content__ttl">{{ get_signal.title }}</h2>
            </div>
            <p class="Wdgt-Signal-Content__description" v-html="get_formattedContent"></p>

            <div class="Wdgt-Signal-Content__content-hdr-section" v-if="get_signal.coin">
              <div class="Wdgt-Signal-Content__content-hdr-btns">
                <button class="Wdgt-Signal-Content__content-hdr-btn" @click="goToForecasters">
                  {{ formattedMentions }} в Форкастерах <ForecastersIcon />
                </button>
                <button class="Wdgt-Signal-Content__content-hdr-btn" @click="goToScreener">
                  <ScreenerIcon /> Скринер
                </button>
              </div>
            </div>
          </div>

          <div class="Wdgt-Signal-Content__params">
            <div class="Wdgt-Signal-Content__bookmark">
              <SignalAddBookmark :id="ID" />
            </div>

            <!-- coin -->
            <a v-if="get_signal.coin" class="Wdgt-Signal-Content__token Coin-Info-Tooltip" :href="get_signal.coin.dropstab_url" target="_blank" :data-coin="get_signal.coin.slug">
              <AvatarImage :size="20" :src="get_signal.coin.image" /> {{ get_signal.coin.symbol }}
            </a>

            <!-- stock_ru -->
            <template v-else-if="get_signal.stock_ru">
              <a
                class="Wdgt-Signal-Content__token"
                :href="get_signal.stock_ru.moex_url"
                target="_blank"
                @mouseenter="onStockEnter"
                @mouseleave="onStockLeave"
              >
                <AvatarImage :size="20" :src="get_signal.stock_ru.logo" /> {{ get_signal.stock_ru.symbol }}
              </a>
              <Teleport to="body">
                <Transition name="stock-tltp">
                  <div
                    v-if="showStockTooltip"
                    ref="stockTooltipRef"
                    class="signals-stock-tltp"
                    :style="stockTooltipStyle"
                    @mouseenter="onStockTooltipEnter"
                    @mouseleave="onStockTooltipLeave"
                  >
                    <div class="signals-stock-tltp__wrapper">
                      <div class="signals-stock-tltp__body">
                        <AvatarImage class="signals-stock-tltp__avatar" :src="get_signal.stock_ru.logo" :size="24" />
                        <div class="signals-stock-tltp__hdr">
                          <span class="signals-stock-tltp__symbol">{{ get_signal.stock_ru.symbol }}</span>
                          <span class="signals-stock-tltp__name">{{ get_signal.stock_ru.name }}</span>
                        </div>
                        <div class="signals-stock-tltp__footer">
                          <p v-if="get_signal.stock_ru.rank" class="signals-stock-tltp__footer-item">
                            <span class="signals-stock-tltp__footer-prefix">#</span>{{ get_signal.stock_ru.rank }}
                          </p>
                          <p class="signals-stock-tltp__footer-item">
                            {{ parseFloat(get_signal.stock_ru.price).toLocaleString('ru-RU', { maximumFractionDigits: 2 }) }} ₽
                          </p>
                          <p
                            class="signals-stock-tltp__footer-item"
                            :class="parseFloat(get_signal.stock_ru.change_percent) >= 0 ? 'signals-stock-tltp__footer-item--green' : 'signals-stock-tltp__footer-item--red'"
                          >
                            {{ parseFloat(get_signal.stock_ru.change_percent) >= 0 ? '+' : '' }}{{ parseFloat(get_signal.stock_ru.change_percent).toFixed(2) }}%
                          </p>
                          <p v-if="get_signal.stock_ru.value" class="signals-stock-tltp__footer-item">
                            {{ formatVolume(get_signal.stock_ru.value, '₽') }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Transition>
              </Teleport>
            </template>

            <!-- usa_stock -->
            <template v-else-if="get_signal.usa_stock">
              <a
                class="Wdgt-Signal-Content__token Coin-Info-Tooltip"
                :href="get_signal.usa_stock.yahoo_url"
                target="_blank"
                @mouseenter="onUsaEnter"
                @mouseleave="onUsaLeave"
              >
                <AvatarImage :size="20" :src="get_signal.usa_stock.logo" /> {{ get_signal.usa_stock.symbol }}
              </a>
              <Teleport to="body">
                <Transition name="stock-tltp">
                  <div
                    v-if="showUsaTooltip"
                    ref="usaTooltipRef"
                    class="signals-stock-tltp"
                    :style="usaTooltipStyle"
                    @mouseenter="onUsaTooltipEnter"
                    @mouseleave="onUsaTooltipLeave"
                  >
                    <div class="signals-stock-tltp__wrapper">
                      <div class="signals-stock-tltp__body">
                        <AvatarImage class="signals-stock-tltp__avatar" :src="get_signal.usa_stock.logo" :size="24" />
                        <div class="signals-stock-tltp__hdr">
                          <span class="signals-stock-tltp__symbol">{{ get_signal.usa_stock.symbol }}</span>
                          <span class="signals-stock-tltp__name">{{ get_signal.usa_stock.name }}</span>
                        </div>
                        <div class="signals-stock-tltp__footer">
                          <p v-if="get_signal.usa_stock.rank" class="signals-stock-tltp__footer-item">
                            <span class="signals-stock-tltp__footer-prefix">#</span>{{ get_signal.usa_stock.rank }}
                          </p>
                          <p class="signals-stock-tltp__footer-item">
                            ${{ parseFloat(get_signal.usa_stock.price).toLocaleString('en-US', { maximumFractionDigits: 2 }) }}
                          </p>
                          <p
                            class="signals-stock-tltp__footer-item"
                            :class="parseFloat(get_signal.usa_stock.change_percent) >= 0 ? 'signals-stock-tltp__footer-item--green' : 'signals-stock-tltp__footer-item--red'"
                          >
                            {{ parseFloat(get_signal.usa_stock.change_percent) >= 0 ? '+' : '' }}{{ parseFloat(get_signal.usa_stock.change_percent).toFixed(2) }}%
                          </p>
                          <p v-if="get_signal.usa_stock.market_cap" class="signals-stock-tltp__footer-item">
                            {{ formatVolume(get_signal.usa_stock.market_cap, '$') }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Transition>
              </Teleport>
            </template>

            <!-- top_asset -->
            <template v-else-if="get_signal.top_asset">
              <a
                class="Wdgt-Signal-Content__token Coin-Info-Tooltip"
                :href="get_signal.top_asset.yahoo_url"
                target="_blank"
                @mouseenter="onTopEnter"
                @mouseleave="onTopLeave"
              >
                <AvatarImage :size="20" :src="get_signal.top_asset.logo" /> {{ get_signal.top_asset.symbol }}
              </a>
              <Teleport to="body">
                <Transition name="stock-tltp">
                  <div
                    v-if="showTopTooltip"
                    ref="topTooltipRef"
                    class="signals-stock-tltp"
                    :style="topTooltipStyle"
                    @mouseenter="onTopTooltipEnter"
                    @mouseleave="onTopTooltipLeave"
                  >
                    <div class="signals-stock-tltp__wrapper">
                      <div class="signals-stock-tltp__body">
                        <AvatarImage class="signals-stock-tltp__avatar" :src="get_signal.top_asset.logo" :size="24" />
                        <div class="signals-stock-tltp__hdr">
                          <span class="signals-stock-tltp__symbol">{{ get_signal.top_asset.symbol }}</span>
                          <span class="signals-stock-tltp__name">{{ get_signal.top_asset.name }}</span>
                          <img v-if="get_signal.top_asset.flag_url" :src="get_signal.top_asset.flag_url" alt="" style="height:14px;margin-left:6px;" />
                        </div>
                        <div class="signals-stock-tltp__footer">
                          <p v-if="get_signal.top_asset.rank" class="signals-stock-tltp__footer-item">
                            <span class="signals-stock-tltp__footer-prefix">#</span>{{ get_signal.top_asset.rank }}
                          </p>
                          <p class="signals-stock-tltp__footer-item">
                            ${{ parseFloat(get_signal.top_asset.price).toLocaleString('en-US', { maximumFractionDigits: 2 }) }}
                          </p>
                          <p
                            class="signals-stock-tltp__footer-item"
                            :class="parseFloat(get_signal.top_asset.change_percent) >= 0 ? 'signals-stock-tltp__footer-item--green' : 'signals-stock-tltp__footer-item--red'"
                          >
                            {{ parseFloat(get_signal.top_asset.change_percent) >= 0 ? '+' : '' }}{{ parseFloat(get_signal.top_asset.change_percent).toFixed(2) }}%
                          </p>
                          <p v-if="get_signal.top_asset.market_cap" class="signals-stock-tltp__footer-item">
                            {{ formatVolume(get_signal.top_asset.market_cap, '$') }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Transition>
              </Teleport>
            </template>

            <!-- polymarket -->
            <template v-else-if="get_signal.polymarket">
              <a
                class="Wdgt-Signal-Content__token Wdgt-Signal-Content__token--poly"
                :href="`https://polymarket.com/event/${get_signal.polymarket.event_slug}`"
                target="_blank"
                @mouseenter="onPolyEnter"
                @mouseleave="onPolyLeave"
              >
                <AvatarImage :size="20" :src="get_signal.polymarket.image_url" :radius="'8px'" />
                {{ get_signal.polymarket_outcome || 'Polymarket' }}
              </a>
              <Teleport to="body">
                <Transition name="stock-tltp">
                  <div
                    v-if="showPolyTooltip"
                    ref="polyTooltipRef"
                    class="signals-stock-tltp"
                    :style="polyTooltipStyle"
                    @mouseenter="onPolyTooltipEnter"
                    @mouseleave="onPolyTooltipLeave"
                  >
                    <div class="signals-stock-tltp__wrapper">
                      <div class="signals-stock-tltp__body">
                        <AvatarImage class="signals-stock-tltp__avatar" :src="get_signal.polymarket.image_url" :size="24" :radius="'8px'" />
                        <div class="signals-stock-tltp__hdr signals-stock-tltp__hdr--poly">
                          <span class="signals-stock-tltp__name">{{ get_signal.polymarket.title }}</span>
                        </div>
                        <div class="signals-stock-tltp__footer">
                          <p
                            v-for="(outcome, i) in polyOutcomes"
                            :key="i"
                            class="signals-stock-tltp__footer-item"
                            :class="i === polyLeaderIndex ? 'signals-stock-tltp__footer-item--green' : ''"
                          >
                            {{ outcome }} {{ polyPricesFormatted[i] }}
                          </p>
                          <p v-if="get_signal.polymarket.volume_usd_24h" class="signals-stock-tltp__footer-item">
                            {{ formatVolume(get_signal.polymarket.volume_usd_24h, '$') }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Transition>
              </Teleport>
            </template>

            <!-- Обычный signal-box -->
            <template v-if="!get_signal.polymarket">
              <div class="Wdgt-Signal-Content__signal-box">
                <div class="Wdgt-Signal-Content__start-stats">
                  <span class="Wdgt-Signal-Content__ttl-value">
                    {{ formatDayAndMonth(get_signal.publication_date || get_signal.created_at) }}
                  </span>
                  <span class="Wdgt-Signal-Content__value">
                    <template v-if="isRub">{{ formatPriceFull(get_signal.start_price_usd) }}₽</template>
                    <template v-else>${{ formatPriceFull(get_signal.start_price_usd) }}</template>
                  </span>
                </div>
                <p
                  class="Wdgt-Signal-Content__change-value"
                  :class="get_signal.change_all_time_percent < 0
                    ? 'Wdgt-Signal-Content__change-value--red'
                    : 'Wdgt-Signal-Content__change-value--green'"
                >
                  <ArrowChangeValue class="Wdgt-Signal-Content__arrow"/>
                  {{ get_signal.change_all_time_percent }}%
                </p>
                <div class="Wdgt-Signal-Content__now-stats">
                  <span class="Wdgt-Signal-Content__ttl-value">Сейчас</span>
                  <span class="Wdgt-Signal-Content__value">
                    <template v-if="isRub">{{ formatPriceFull(get_signal.price_usd) }}₽</template>
                    <template v-else>${{ formatPriceFull(get_signal.price_usd) }}</template>
                  </span>
                </div>
              </div>

              <div class="Wdgt-Signal-Content__mcap">
                <span class="Wdgt-Signal-Content__ttl-value">Мкап</span>
                <span class="Wdgt-Signal-Content__value Wdgt-Signal-Content__value--pale">
                  <template v-if="isRub">{{ formatPrice(asset_marketCap) }}₽</template>
                  <template v-else>${{ formatPrice(asset_marketCap) }}</template>
                </span>
              </div>
            </template>

            <!-- Polymarket signal-box -->
            <template v-else>
              <div class="Wdgt-Signal-Content__signal-box">
                <div class="Wdgt-Signal-Content__start-stats">
                  <span class="Wdgt-Signal-Content__ttl-value">
                    {{ formatDayAndMonth(get_signal.publication_date || get_signal.created_at) }}
                  </span>
                  <span class="Wdgt-Signal-Content__value">
                    {{ polyStartPrice ?? '—' }}
                  </span>
                </div>
                <p
                  class="Wdgt-Signal-Content__change-value"
                  :class="get_signal.change_all_time_percent < 0
                    ? 'Wdgt-Signal-Content__change-value--red'
                    : 'Wdgt-Signal-Content__change-value--green'"
                >
                  <ArrowChangeValue class="Wdgt-Signal-Content__arrow"/>
                  {{ get_signal.change_all_time_percent }}%
                </p>
                <div class="Wdgt-Signal-Content__now-stats">
                  <span class="Wdgt-Signal-Content__ttl-value">Сейчас</span>
                  <span class="Wdgt-Signal-Content__value">
                    {{ polyCurrentPrice ?? '—' }}
                  </span>
                </div>
              </div>

              <div class="Wdgt-Signal-Content__mcap">
                <span class="Wdgt-Signal-Content__ttl-value">Ссылка</span>
                <a
                  class="Wdgt-Signal-Content__poly-platform-link"
                  :href="`https://polymarket.com/event/${get_signal.polymarket.event_slug}`"
                  target="_blank"
                >Polymarket <LinkExternalIcon /></a>
              </div>
            </template>
          </div>

          <p class="Wdgt-Signal-Content__high-low-container" v-if="get_signal.ath_date || get_signal.atl_date">
            <template v-if="get_signal.ath_date">
              Хай <span class="Wdgt-Signal-Content__high-low-value Wdgt-Signal-Content__high-low-value--green">{{ get_signal.change_ath }}%</span>
              был через {{ timeDiffShort(get_signal.ath_date, get_signal.publication_date) }} после сигнала,
            </template>
            <template v-if="get_signal.atl_date">
              Лой <span class="Wdgt-Signal-Content__high-low-value Wdgt-Signal-Content__high-low-value--red">{{ get_signal.change_atl }}%</span>
              был через {{ timeDiffShort(get_signal.atl_date, get_signal.publication_date) }} после сигнала
            </template>
          </p>

          <div class="Wdgt-Signal-Content__content-ftr-box" v-if="get_signal.images_list.length">
            <div class="Wdgt-Signal-Content__images">
              <img
                class="Wdgt-Signal-Content__cover"
                v-for="(img, index) in get_signal.images_list"
                :key="index"
                :src="img"
                @click="openSlider(index)"
              />
            </div>
          </div>
        </div>

        <div class="Wdgt-Signal-Content__reactions">
          <ContentReactions :signalId="get_signal.id"/>
        </div>

        <ContentComments
          class="Wdgt-Signal-Content__content-comments"
          :commentsPlace="props.commentsPlace"
          :signalId="ID"
          ref="comments"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { computed, ref, onMounted, onBeforeUnmount, nextTick, watch } from 'vue';
  import { formatDayAndMonth, timeDiffShort } from '@shared/utils/time/formated';
  import { sliderImagesGroupDisplay } from '@/Groups/Slider/public/utils/callSlider.js';
  import { formatPriceFull, formatPrice, formatVolume } from '@shared/utils/price/formatedPrice.js';
  import { useStockTooltip } from '@shared/composables/tooltip/useStockTooltip';
  import { callForecasterCoinFilter } from '@/Groups/Forecasters/public/utils/activeForecasterFilter.js';
  import { callScreenerInnerPage } from '@/Groups/Signals/private/imports/screenerImports.js';
  import { PATHS_NAME } from '@shared/routers/consts/pathsName.js';
  import { getSignalMentionsCount } from './api/getPostsCount.js';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';

  import BlockAuthorTimeCommentFire from '@ui/Blocks/BlockAuthorTimeCommentFire/BlockAuthorTimeCommentFire.vue';
  import ContentReactions from '@widgets/ContentWidget/general/Reactions/ContentReactions.vue';
  import ContentComments from '@widgets/ContentWidget/general/Comments/ContentComments.vue';
  import DropMenuSignal from '@features/DropMenu/modules/DropMenuSignal/DropMenuSignal.vue';
  import PointsIcon from '@/Groups/Signals/private/svg/PointsIcon.vue';
  import ForecastersIcon from '@shared/UI/Svg_new/navigations/Forecasters.vue';
  import ScreenerIcon from '@/Groups/Signals/private/svg/ScreenerIcon.vue';
  import SignalAddBookmark from '@/Groups/Signals/private/core/SignalAddBookmark/SignalAddBookmark.vue';
  import CapitalInfo from '@widgets/ContentWidget/general/CapitalInfo/CapitalInfo.vue';
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  import ArrowChangeValue from '@shared/UI/SVG/arrows/ArrowChangeValues.vue';
  import LinkExternalIcon from '@shared/UI/Svg_new/ui/LinkExternal.vue';

  const store = useStore();
  const props = defineProps(Props());
  const router = useRouter();
  const ID = window.location.pathname.match(/\/signal\/(\d+)/)[1];

  const isOpen = ref(false);
  const menuRef = ref(null);
  const comments = ref(null);
  const observer = ref(null);
  const authorRef = ref(null);
  const mentionsCount = ref(0);

  // Тултипы через composable
  const {
    tooltipRef: stockTooltipRef, showTooltip: showStockTooltip, tooltipStyle: stockTooltipStyle,
    open: openStockTlp, close: closeStockTlp, scheduleClose: scheduleStockClose, cancelClose: cancelStockClose,
  } = useStockTooltip();

  const {
    tooltipRef: polyTooltipRef, showTooltip: showPolyTooltip, tooltipStyle: polyTooltipStyle,
    open: openPolyTlp, close: closePolyTlp, scheduleClose: schedulePolyClose, cancelClose: cancelPolyClose,
  } = useStockTooltip();

  const {
    tooltipRef: usaTooltipRef, showTooltip: showUsaTooltip, tooltipStyle: usaTooltipStyle,
    open: openUsa, close: closeUsa, scheduleClose: scheduleUsaClose, cancelClose: cancelUsaClose,
  } = useStockTooltip();

  const {
    tooltipRef: topTooltipRef, showTooltip: showTopTooltip, tooltipStyle: topTooltipStyle,
    open: openTop, close: closeTop, scheduleClose: scheduleTopClose, cancelClose: cancelTopClose,
  } = useStockTooltip();

  const get_isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
  const get_signal = computed(() => store.state.Signals.data[ID]);
  const get_time = computed(() => get_signal.value?.publication_date || get_signal.value?.created_at);
  const get_isLockPaidContent = computed(() => !store.getters['UserSystem/hasPaidAccess']);
  const get_isUserLoading = computed(() => !store.state.UserSystem.isReady && store.state.UserSystem.user.isAuthenticated);

  const isRub = computed(() => !!get_signal.value?.stock_ru);

  const asset_marketCap = computed(() => {
    if (get_signal.value?.coin) return get_signal.value.coin.market_cap;
    if (get_signal.value?.stock_ru) return get_signal.value.stock_ru.market_cap;
    if (get_signal.value?.usa_stock) return get_signal.value.usa_stock.market_cap;
    if (get_signal.value?.top_asset) return get_signal.value.top_asset.market_cap;
    return null;
  });

  // POLYMARKET
  const polyOutcomes = computed(() => {
    const poly = get_signal.value?.polymarket;
    if (!poly) return [];
    try { return JSON.parse(poly.outcomes); } catch { return []; }
  });

  const polyPrices = computed(() => {
    const poly = get_signal.value?.polymarket;
    if (!poly) return [];
    try { return JSON.parse(poly.outcome_prices); } catch { return []; }
  });

  const polyPricesFormatted = computed(() => {
    return polyPrices.value.map(p => `${(parseFloat(p) * 100).toFixed(1)}¢`);
  });

  // Цена сейчас считается бэком для signal.polymarket_outcome
  const polyCurrentPrice = computed(() => {
    const priceUsd = get_signal.value?.price_usd;
    if (priceUsd == null) return null;
    return `${(parseFloat(priceUsd) * 100).toFixed(1)}¢`;
  });

  const polyStartPrice = computed(() => {
    if (get_signal.value?.start_price_usd) {
      return `${(parseFloat(get_signal.value.start_price_usd) * 100).toFixed(1)}¢`;
    }
    return null;
  });

  const polyLeaderIndex = computed(() => {
    if (!polyPrices.value.length) return 0;
    const prices = polyPrices.value.map(Number);
    return prices.indexOf(Math.max(...prices));
  });

  // Обёртки для template — передаём DOM-элемент из события
  const onStockEnter = (e) => openStockTlp(e.currentTarget);
  const onStockLeave = () => scheduleStockClose();
  const onStockTooltipEnter = () => cancelStockClose();
  const onStockTooltipLeave = () => closeStockTlp();

  const onPolyEnter = (e) => openPolyTlp(e.currentTarget);
  const onPolyLeave = () => schedulePolyClose();
  const onPolyTooltipEnter = () => cancelPolyClose();
  const onPolyTooltipLeave = () => closePolyTlp();

  const onUsaTooltipEnter = () => cancelUsaClose();
  const onUsaTooltipLeave = () => closeUsa();
  const onUsaEnter = (e) => openUsa(e.currentTarget);
  const onUsaLeave = () => scheduleUsaClose();

  const onTopTooltipEnter = () => cancelTopClose();
  const onTopTooltipLeave = () => closeTop();
  const onTopEnter = (e) => openTop(e.currentTarget);
  const onTopLeave = () => scheduleTopClose();

  const formattedMentions = computed(() => {
    if (get_signal.value?.count_of_mentions !== undefined) {
      const count = get_signal.value.count_of_mentions;
      return `${count} ${declinePosts(count)}`;
    }
    const count = mentionsCount.value !== null ? mentionsCount.value : 0;
    return `${count} ${declinePosts(count)}`;
  });

  const userAvatar = computed(() => {
    const signal = get_signal.value;
    const tg = signal.telegram_user;
    if (tg) {
      if (tg.image_url) return tg.image_url;
      if (signal.author?.username && signal.author.username === tg.username) return signal.author.avatar || null;
      return null;
    }
    return signal.author?.avatar || null;
  });

  const get_formattedContent = computed(() => {
    if (!get_signal.value?.content) return '';
    const urlRegex = /(https?:\/\/|ftp:\/\/|www\.)[^\s/$.?#].[^\s]*/gi;
    return get_signal.value.content
      .replace(urlRegex, url => {
        const fullUrl = url.startsWith('www.') ? `http://${url}` : url;
        return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      })
      .replace(/\n/g, '<br>');
  });

  const computedName = computed(() => {
    const tg = get_signal.value.telegram_user;
    const author = get_signal.value.author;
    if (tg?.first_name || tg?.last_name) return `${tg.first_name ?? ''} ${tg.last_name ?? ''}`.trim();
    return author?.name || '';
  });

  const updateAuthorWidth = async () => {
    await nextTick();
    if (!authorRef.value) return;
    const parent = authorRef.value.parentNode;
    const width = (get_signal.value?.author?.username || get_signal.value?.telegram_user)
      ? authorRef.value.offsetWidth + 6
      : 0;
    parent.style.setProperty('--author-width', `${width}px`);
  };

  watch(get_signal, newVal => { if (newVal) updateAuthorWidth(); }, { immediate: true });

  const loadMentionsCount = async () => {
    try {
      const data = await getSignalMentionsCount(ID);
      mentionsCount.value = data.count_of_mentions || 0;
    } catch (error) {
      console.error('Ошибка загрузки количества упоминаний:', error);
      mentionsCount.value = 0;
    }
  };

  const toCallComments = () => {
    const scrollItem = comments.value?.$refs.contentComments;
    const scrollModal = document.querySelector('[data-content-scroll-wrapper]');
    const pageScroll = document.querySelector('[page-article]');
    if (!scrollItem) return;
    const rect = scrollItem.getBoundingClientRect();
    if (scrollModal) {
      scrollModal.scrollTo({ top: scrollModal.scrollTop + rect.top - 70, behavior: 'auto' });
    } else if (pageScroll) {
      window.scrollTo({ top: window.scrollY + rect.top - 70, behavior: 'auto' });
    }
  };

  const toToggleMenu = () => isOpen.value = !isOpen.value;
  const handleClickOutside = event => { if (menuRef.value && !menuRef.value.contains(event.target)) isOpen.value = false; };
  const openSlider = index => sliderImagesGroupDisplay(get_signal.value.images_list.map(img => ({ url: img, caption: null })), index);

  const observeCommentsVisibility = () => {
    const target = comments.value?.$el;
    if (!target) return;
    observer.value = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) store.dispatch('Signals/updateCommentsCounter', { id: ID, isAlignValues: true }); },
      { root: null, rootMargin: '0px', threshold: 0.1 }
    );
    observer.value.observe(target);
  };

  const goToForecasters = () => {
    const coin = get_signal.value.coin;
    router.push({ name: PATHS_NAME.FORECASTERS });
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
    callForecasterCoinFilter(coin);
  };

  const goToScreener = () => {
    const coin = get_signal.value.coin;
    router.push({ name: PATHS_NAME.SCANNER });
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
    callScreenerInnerPage(coin);
  };

  const declinePosts = (number) => {
    const lastTwo = number % 100;
    const lastOne = number % 10;
    if (lastTwo >= 11 && lastTwo <= 19) return 'постов';
    if (lastOne === 1) return 'пост';
    if (lastOne >= 2 && lastOne <= 4) return 'поста';
    return 'постов';
  };

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
    if (!get_signal.value.count_of_mentions) loadMentionsCount();
    observeCommentsVisibility();
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>